import { render, staticRenderFns } from "./trainCourseEdit.vue?vue&type=template&id=9132b1be&scoped=true&"
import script from "./trainCourseEdit.vue?vue&type=script&lang=js&"
export * from "./trainCourseEdit.vue?vue&type=script&lang=js&"
import style0 from "./trainCourseEdit.vue?vue&type=style&index=0&id=9132b1be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9132b1be",
  null
  
)

export default component.exports